const { getTempInfo } = require('../../shared/tempInfo');
module.exports = (PiNode) => {
  Object.defineProperties(PiNode.prototype, {
    tempInfo: {
      get() {
        return getTempInfo(this.data);
      },
    },
  });
};
